const IScroll = window.IScroll;
export default IScroll;


// WEBPACK FOOTER //
// ./web/js/alias/iscroll.js